import Vue from "vue"
import i18n from "@/locales"

import updatePrompt from "./update-prompt.vue"
const UpdatePrompt = Vue.extend(updatePrompt)

export const createUpdatePrompt = ({
  onAccept,
  onReject,
}: {
  onAccept: () => void
  onReject: () => void
}) => {
  const prompt = new UpdatePrompt({
    i18n,
    propsData: {
      onAccept,
      onReject,
    },
  })

  const el = prompt.$mount().$el
  document.body.appendChild(el)

  return {
    dismiss() {
      prompt.$destroy()
      document.body.removeChild(el)
    },
  }
}
